import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
const Swap: FC = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none"><g clipPath="url(#clip0_7153_2949)"><path d="M11 8H20" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M17 4L21 8L17 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M13 16H4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M7 20L3 16L7 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></g></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default Swap;